import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import PartnerStateContainer from '../../Components/UserInitializer/PartnerStateContainer';
import AdminEditorComponent from './AdminEditorComponent';
import { useParams } from 'react-router';
import { useAgeReadyContext } from '../../AgeReadyContext/AgeReadyContext';
import { Header, Loader } from 'semantic-ui-react';
import { DummyPartner } from '../../Models/MedicalAssessmentData';
import { Tab } from 'semantic-ui-react';
import ResourcesEditor from './ResourcesEditor';

const AdminConsolePage: React.FC = () => {
  const { partnerStore } = useAgeReadyContext();
  const { partnerId } = useParams<{ partnerId: string }>();
  const [partnerLoaded, setPartnerLoaded] = useState(false);

  useEffect(() => {
    const existingPartner = partnerStore.partnersByIdMap.get(partnerId);

    if (!existingPartner) {
      partnerStore.loadPartner(partnerId).then(() => {
        const partner = partnerStore.partnersByIdMap.get(partnerId);

        if (partner?.resources.length === 0) {
          partner?.setResources(DummyPartner.resources);
        }
        setPartnerLoaded(true);
      });
    } else {
      setPartnerLoaded(true);
    }
  }, [partnerStore, partnerId]);

  if (!partnerLoaded) {
    return <Loader active={true} />;
  }

  const panes = [
    {
      menuItem: 'Appearance',
      render: () => (
        <Tab.Pane>
          <AdminEditorComponent />
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'Resources',
      render: () => (
        <Tab.Pane>
          <ResourcesEditor />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <>
      <PartnerStateContainer>
        <Header>
          Admin Portal
          <Header.Subheader>
            Your Group Code is <b>{partnerId}</b>
          </Header.Subheader>
        </Header>
        <Tab panes={panes} />
      </PartnerStateContainer>
    </>
  );
};

export default observer(AdminConsolePage);
